import { BarcodeOutlined, CloseOutlined } from 'yoc-ui-library/icons';

import { classesBuilder } from '@common/helpers';
import Icon from '@components/Icon';
import Safe from '@components/LoginAnimation/Safe';

import { LOGIN_FIELDS } from './constants';
import { useLoginForm } from './hooks';

import style from './styles.module.scss';

const LoginPage = () => {
  const {
    purchaseOrderNo,
    vaultKey,
    error,
    showBorder,
    onChange,
    onBlur,
    onFocus,
    onSubmit,
    isReportLoading,
    globalError,
    clearGlobalError,
  } = useLoginForm();

  return (
    <form
      className={classesBuilder(style['login-form-wrapper'])}
      onSubmit={onSubmit}
    >
      <div className={style.heading}>
        <Safe isLoggingIn={isReportLoading} />
        <div className={style.title}>
          <h1>WELCOME</h1>
          <p>Sign in to access Deal Vault®</p>
        </div>
      </div>

      {globalError && (
        <div className={style['global-error-container']}>
          <div className={style['custom-alert']}>
            <div className={style['alert-content']}>{globalError}</div>
            <button
              type="button"
              className={style['close-btn']}
              onClick={clearGlobalError}
              aria-label="Close error"
            >
              <CloseOutlined size={20} />
            </button>
          </div>
        </div>
      )}
      <div className={style['input-wrapper']}>
        <BarcodeOutlined className={style['input-icon']} />
        <input
          className={classesBuilder(style.input, {
            [style.error]: showBorder.purchaseOrderNo,
          })}
          type="text"
          name={LOGIN_FIELDS.PURCHASE_ORDER_NO}
          placeholder="Report ID"
          value={purchaseOrderNo}
          onChange={onChange(LOGIN_FIELDS.PURCHASE_ORDER_NO)}
          onBlur={() => {
            return onBlur(LOGIN_FIELDS.PURCHASE_ORDER_NO);
          }}
          onFocus={() => {
            return onFocus(LOGIN_FIELDS.PURCHASE_ORDER_NO);
          }}
          autoComplete="off"
          disabled={isReportLoading}
        />
        {error.purchaseOrderNo && <span className={style['error-text']}>{error.purchaseOrderNo}</span>}
      </div>

      <div className={style['input-wrapper']}>
        <Icon
          name="key"
          className={style['input-icon']}
        />
        <input
          className={classesBuilder(style.input, {
            [style.error]: showBorder.vaultKey,
          })}
          type="password"
          name={LOGIN_FIELDS.KEY}
          placeholder="Key"
          value={vaultKey}
          onChange={onChange(LOGIN_FIELDS.KEY)}
          onBlur={() => {
            return onBlur(LOGIN_FIELDS.KEY);
          }}
          onFocus={() => {
            return onFocus(LOGIN_FIELDS.KEY);
          }}
          autoComplete="current-password"
          disabled={isReportLoading}
        />
        {error.vaultKey && <span className={style['error-text']}>{error.vaultKey}</span>}
      </div>

      <button
        type="submit"
        className={classesBuilder(style['login-btn'], {
          [style['is-loading']]: isReportLoading,
        })}
        disabled={isReportLoading}
      >
        {isReportLoading ? 'Accessing vault...' : 'Open Vault'}
      </button>
    </form>
  );
};

export default LoginPage;
